import React, { useState, useEffect } from 'react';
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from '/src/components/modal/hooks/useModalHelper';
import Modal from "/src/components/modal/Modal";
import Button from "/src/components/UI/Button/Button";
import { DateRange } from '/src/lib/react-date-range/index';
import AnalyticsModalDatePickerCustomDisplay from '/src/features/supervision/analytics/components/AnalyticsModal/AnalyticsModalDatePicker/AnalyticsModalDatePickerCustomDisplay';
import format from 'date-fns/format';

const DateRangeCustom = NiceModal.create(({ daysBack, className,onDateRangeSelection, ...restProps }) => {
  const modal = useModal();
  const { onClose } = useModalHelper(modal);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: 'selection'
    }
  ]);

  const handleGetSelectedDate = () => {
    // Récupérer la date sélectionnée
    let selectedStartDate = state[0].startDate;
    let selectedEndDate = state[0].endDate;
  
    // Formater les dates dans le format 'yyyy-MM-dd'
    let formattedStartDate = format(selectedStartDate, 'yyyy-MM-dd');
    let formattedEndDate = format(selectedEndDate, 'yyyy-MM-dd');
    onDateRangeSelection(formattedStartDate, formattedEndDate);
    onClose();
  };

  return (
    <Modal name="date_range" id={modal.id} onClose={onClose}>
      <div className="leave-container">
          <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
              <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
          </div>
      </div>
      <form className='variables_modal'>
        <div className='area-edit'>
          <DateRange
            editableDateInputs={true}
            onChange={item => setState([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={state}
            rangeColors={['#65abf61a', '#0e7aed', '#65abf61a']}
            navigatorRenderer={AnalyticsModalDatePickerCustomDisplay}
            dateDisplayFormat="dd/MM/yyyy"
            direction="horizontal"
          />
        </div>
         <Button style={{marginLeft:"200px"}} label="Update" type="button"  className="validate" onClick={()=>{handleGetSelectedDate()}}/>
      </form>
    </Modal>
  );
})

DateRangeCustom.defaultProps = {
  className: 'full-width input-space',
  type: 'date',
  autoComplete: 'off'
}

export default DateRangeCustom;
